module.exports = __webpack_public_path__ + "static/media/LQ_Fashion_Necchi_Blue_Orange.8117bf96.png";